import { PiedPage } from "./piedPage";
export default PiedPage;